import ProductPreview from './PreviewElements';
// import loadable from '@loadable/component'
// const  ProductPreview = loadable(() => import('./PreviewElements'))
export default ProductPreview;
